import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { formatDate } from '@/helpers/date-helpers';

interface DatePagerProps {
  dates: string[];
  currentIndex: number;
  onPrevious: () => void;
  onNext: () => void;
}

export function DatePager({ dates, currentIndex, onPrevious, onNext }: DatePagerProps) {
  const isAtStart = currentIndex === 0;
  const isAtEnd = dates.length === 0 || currentIndex === dates.length - 1;

  const previousDate = !isAtStart ? dates[currentIndex - 1] : null;
  const nextDate = !isAtEnd ? dates[currentIndex + 1] : null;

  return (
    <TooltipProvider>
      <div className='flex items-center gap-1 ml-auto pr-2'>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              onClick={onPrevious}
              disabled={isAtStart}
              className={`
                p-1 rounded transition-colors
                ${isAtStart ? 'text-blue-300 cursor-not-allowed' : 'text-white hover:text-blue-200 hover:bg-blue-800'}
              `}
              aria-label='Previous date'
            >
              <ChevronLeft size={16} />
            </Button>
          </TooltipTrigger>
          {previousDate && (
            <TooltipContent>
              <p>{formatDate(previousDate)}</p>
            </TooltipContent>
          )}
        </Tooltip>

        <span className='text-white'>{formatDate(dates[currentIndex])}</span>

        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              onClick={onNext}
              disabled={isAtEnd}
              className={`
                p-1 rounded transition-colors
                ${isAtEnd ? 'text-blue-300 cursor-not-allowed' : 'text-white hover:text-blue-200 hover:bg-blue-800'}
              `}
              aria-label='Next date'
            >
              <ChevronRight size={16} />
            </Button>
          </TooltipTrigger>
          {nextDate && (
            <TooltipContent>
              <p>{formatDate(nextDate)}</p>
            </TooltipContent>
          )}
        </Tooltip>
      </div>
    </TooltipProvider>
  );
}
